import { FormControlLabel, Switch, TextField } from '@mui/material';
import BoxWithTitle from 'components/shared/box-with-title.component';
import { DenthubTransport } from 'models/organization';
import React, { ChangeEvent, FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

type DenthubTransportSettingsProps = {
    denthubTransport: DenthubTransport;
    onToggleTransport: (isEnabled: boolean) => void;
    onExternalIdChange: (externalId: string) => void;
};

const DenthubTransportSettings: FC<DenthubTransportSettingsProps> = ({
    denthubTransport,
    onToggleTransport,
    onExternalIdChange,
}: DenthubTransportSettingsProps) => {
    const { t: translate } = useTranslation('transport');
    const [isDenthubTransportEnabled, setIsDenthubTransportEnabled] = useState(false);
    const [externalId, setExternalId] = useState('');

    useEffect(() => {
        if (denthubTransport) {
            setIsDenthubTransportEnabled(denthubTransport.isEnabled || false);
            setExternalId(denthubTransport.externalId || '');
        }
    }, [denthubTransport]);

    const toggleTransport = (event: ChangeEvent<HTMLInputElement>) => {
        setIsDenthubTransportEnabled(event.target.checked);
        onToggleTransport(event.target.checked);
    };

    const handleExternalIdChange = (event: ChangeEvent<HTMLInputElement>) => {
        setExternalId(event.target.value);
        onExternalIdChange(event.target.value);
    };

    return (
        <BoxWithTitle title={translate('transport:DENTHUB_TRANSPORT')}>
            <FormControlLabel
                control={
                    <Switch
                        color="secondary"
                        value={isDenthubTransportEnabled}
                        checked={isDenthubTransportEnabled}
                        onChange={toggleTransport}
                    />
                }
                label={translate('transport:ENABLE_TRANSPORT')}
            />
            {isDenthubTransportEnabled ? (
                <TextField
                    margin="dense"
                    value={externalId}
                    label={translate('transport:EXTERNAL_ID')}
                    required={isDenthubTransportEnabled}
                    fullWidth={true}
                    onChange={handleExternalIdChange}
                />
            ) : undefined}
        </BoxWithTitle>
    );
};

export default DenthubTransportSettings;
